import { Navigate } from 'react-router-dom'
import Page from 'pages/page'
import createLoader from 'router/loaders'

const loader = createLoader()

const childrenRoutes = [
  {
    path: 'review',
    element: <Page />,
    loader,
  },
  {
    path: 'forecasts/:studyfield?',
    element: <Page />,
    loader,
  },
  {
    path: 'reports/:reportId?/:id?',
    element: <Page />,
    loader,
  },
  {
    path: 'newsletter/:id?',
    element: <Page />,
    loader,
  },
  {
    path: 'newsletters',
    element: <Page />,
    loader,
  },
  {
    index: true,
    element: <Navigate to="/review?period=week" />,
  },
]

export default childrenRoutes
